import { Injectable } from '@angular/core';
import { map } from 'rxjs/internal/operators/map';
import { HttpMethodsService } from '../_helpers/http-methods.service';
import { PendingUserConstants } from './constants/pendingUsers.constant';
import { BehaviorSubject } from 'rxjs/index';
import { ActiveUserConstants } from '../activeusers_api/constatnts/activeusers.constant';

@Injectable({
  providedIn: 'root'
})
export class PendingUsersService {
  userId = sessionStorage.getItem(PendingUserConstants.USER_ID);
  loginUserRole = sessionStorage.getItem(PendingUserConstants.USER_ROLE);
  RETAIL_STORE_COMMON_URL = PendingUserConstants.AND_STATUS + PendingUserConstants.EQUALS + PendingUserConstants.PENDING;
  COMMON_URL = PendingUserConstants.SLASH_USER_MANAGEMENT + PendingUserConstants.USER_MANAGEMENT + PendingUserConstants.SLASH_USER;
  PENDING_USERS_URL = `${this.COMMON_URL}${PendingUserConstants.STATUS_ACTIVE}${PendingUserConstants.EQUALS
    }${PendingUserConstants.PENDING}${PendingUserConstants.PAGE_NUMBER}${PendingUserConstants.EQUALS}`;
  RETAILHQ_USER_URL = `${this.COMMON_URL}${PendingUserConstants.SLASH}${this.userId}${PendingUserConstants.SLASH_RETAIL
    }${PendingUserConstants.RETAILERID}${PendingUserConstants.EQUALS}`;

  REGIONAL_URL = `${this.COMMON_URL}${PendingUserConstants.SLASH}${this.userId}${PendingUserConstants.SLASH_RETAIL
    }${PendingUserConstants.RETAILERID}${PendingUserConstants.EQUALS}`;
  REGIONAL_COMMON_URL = `${this.RETAIL_STORE_COMMON_URL}${PendingUserConstants.PAGE_NUMBER}${PendingUserConstants.EQUALS}`;
  PENDING_USER_URL_GET_ALL = `${this.COMMON_URL}${PendingUserConstants.SLASH}${this.userId}${PendingUserConstants.SLASH_RETAIL
    }${PendingUserConstants.RETAILERID}${PendingUserConstants.EQUALS}`;

  PENDING_USERS_URL_GET_ALL = `${this.COMMON_URL}${PendingUserConstants.STATUS_ACTIVE}${PendingUserConstants.EQUALS
    }${PendingUserConstants.PENDING}`;

  private pendingUsersCount = new BehaviorSubject('');
  pendingUsersNum = this.pendingUsersCount.asObservable();

  constructor(private httpMethod: HttpMethodsService) { }

  getAllPendingUsers(pageNumber: number, filterString?: string, retailerId?: string) {
    let url = (this.loginUserRole === PendingUserConstants.RETAIL_USER_ROLE) ?
      `${this.RETAILHQ_USER_URL + sessionStorage.getItem(PendingUserConstants.RETAILER_ID) + this.RETAIL_STORE_COMMON_URL + PendingUserConstants.PAGE_NUMBER + PendingUserConstants.EQUALS + pageNumber}`
      : (this.loginUserRole === ActiveUserConstants.REGIONAL_USER_ROLE) ? `${this.REGIONAL_URL + sessionStorage.getItem(PendingUserConstants.RETAILER_ID) + this.REGIONAL_COMMON_URL + pageNumber}` : `${this.PENDING_USERS_URL + pageNumber}`;

    if (filterString) {
      url = `${url}${filterString}`;
    }

    return this.httpMethod.get(url)
      .pipe(map((res: any) =>
        res));
  }

  getUsersbySearch(searchTag: string, searchData: any, pagenumber: number) {
    const URL = (this.loginUserRole === PendingUserConstants.RETAIL_USER_ROLE || this.loginUserRole === ActiveUserConstants.REGIONAL_USER_ROLE) ?
      `${this.RETAILHQ_USER_URL + sessionStorage.getItem(PendingUserConstants.RETAILER_ID) + this.RETAIL_STORE_COMMON_URL + PendingUserConstants.PAGE_NUMBER + PendingUserConstants.EQUALS + pagenumber}`
      : `${this.PENDING_USERS_URL + pagenumber}`;

    return this.httpMethod.get(`${URL}${PendingUserConstants.AND}${searchTag}${PendingUserConstants.EQUALS}${searchData}`)
      .pipe(map((res: any) =>
        res));
  }

  sort(globalSortValue: string, temporder: string, pagenumber: number) {
    const URL = (this.loginUserRole === PendingUserConstants.RETAIL_USER_ROLE || this.loginUserRole === ActiveUserConstants.REGIONAL_USER_ROLE) ?
      `${this.RETAILHQ_USER_URL + sessionStorage.getItem(PendingUserConstants.RETAILER_ID) + this.RETAIL_STORE_COMMON_URL + PendingUserConstants.PAGE_NUMBER + PendingUserConstants.EQUALS + pagenumber}` :
      this.COMMON_URL + PendingUserConstants.STATUS_ACTIVE + pagenumber + PendingUserConstants.EQUALS +
      PendingUserConstants.PENDING;

    return this.httpMethod.get(URL + PendingUserConstants.AND + PendingUserConstants.SORT_BY
      + globalSortValue + PendingUserConstants.SORT_TYPE + temporder)
      .pipe(map((res: any) =>
        res));
  }

  approvePendingUserRequest(userIds: string) {
    return this.httpMethod.patch(this.COMMON_URL, userIds)
      .pipe(map((res: any) =>
        res));
  }

  rejectPendingUserRequest(userIds: any) {
    return this.httpMethod.deleteUser(this.COMMON_URL, userIds)
      .pipe(map((res: any) =>
        res));
  }

  checkPendingUsersCount(counter) {
    this.pendingUsersCount.next(counter);
  }
  selectAllGetData(filterString?: string) {
    let url = (this.loginUserRole === PendingUserConstants.RETAIL_USER_ROLE || this.loginUserRole === ActiveUserConstants.REGIONAL_USER_ROLE) ?
      `${this.PENDING_USER_URL_GET_ALL + sessionStorage.getItem(PendingUserConstants.RETAILER_ID) + this.RETAIL_STORE_COMMON_URL}`
      : `${this.PENDING_USERS_URL_GET_ALL}`;
    if (filterString) {
      url = `${url}${filterString}`;
    }

    return this.httpMethod.get(url)
      .pipe(map((res: any) =>
        res));

  }
}
